import BMContent from './BMContent';
export default BMContent;
